import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/slot-overrides/slot-overrides.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
